import React, { useEffect, useState } from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import Breadcrumb from '../Breadcrumb'
import TicketPageTable from './TicketPageTable'
import { API_URL } from '../..'
import { Spinner } from 'react-bootstrap'
import ClosedTicketTable from './ClosedTicketTable'

export default function TicketPage() {
    const [dataActive,setDataActive] = useState([])
    const [dataClosed,setDataClosed] = useState([])
    const [isLoading,setIsLoading] = useState(false);

    const fetchTickets = async ()=>{
        setIsLoading(true)
        const getCurrent = JSON.parse(localStorage.getItem('user'));
         const fetchApi = await  fetch(API_URL+ '/api/ticket/affiliate/'+getCurrent?.id , {method:'GET' });
         const response = await  fetchApi.json();
         if(fetchApi.status === 200){
            const filterActive = response?.tickets?.filter((item)=>item.status === 'Open' || item.status === 'In Progress')
            const filterClosed = response?.tickets?.filter((item)=>item.status === 'Resolved' || item.status === 'Closed')
             setDataActive(filterActive);
             setDataClosed(filterClosed)
         }
         setIsLoading(false)
    }
    useEffect(()=>{
        fetchTickets()
    },[])
  return (
    <MasterLayout>
    <Breadcrumb title="Ticket" />

    <div className="row gy-4">
         <div className='col-md-12'>
         
            <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
               
                <div className="card-body p-24 pt-10">
                    <ul
                        className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-16"
                        id="pills-tab"
                        role="tablist"
                    >
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link px-16 py-10 active"
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                type="button"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected="true"
                            >
                                Active Tickets
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link px-16 py-10"
                                id="pills-details-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-details"
                                type="button"
                                role="tab"
                                aria-controls="pills-details"
                                aria-selected="false"
                            >
                                Closed Tickets
                            </button>
                        </li>
                       
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className="tab-pane fade show active"
                            id="pills-home"
                            role="tabpanel"
                            aria-labelledby="pills-home-tab"
                            tabIndex={0}
                        >
                             {
                                isLoading === true ? 
                                <Spinner/>:
                                <TicketPageTable status="active" jobsData={dataActive}/>

                             }
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-details"
                            role="tabpanel"
                            aria-labelledby="pills-details-tab"
                            tabIndex={0}
                        >
                          {
                                isLoading === true ? 
                                <Spinner/>:
                                <ClosedTicketTable status="closed" jobsData={dataClosed}/>

                             }
                        </div>
                     
                    </div>
                </div>
            </div>
        
         </div>
        </div>
        </MasterLayout>
  )
}
